<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let name = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let placeholder = null;
	export let rows = 3;
	export let required = null;
	export let disabled = null;
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
{#if !disabled}
	<textarea {required} {disabled} {id} {name} {maxlength} {rows} {placeholder} bind:value class="form-control" />
{:else}
	<div {id} class="form-control disabled-text">
		{value || placeholder || ""}
	</div>
{/if}

<style>
	textarea {
		height: auto;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.375rem 0.75rem;
		font-size: 1rem;
		line-height: 1.5;
		color: #495057;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		border-radius: 0.25rem;
		transition:
			border-color 0.15s ease-in-out,
			box-shadow 0.15s ease-in-out;
	}

	.form-control.disabled-text {
		background-color: var(--color-soft);
		border-color: #ced4da;
		color: #6c757d;
		padding: 0.375rem 0.75rem;
		display: flex;
		align-items: center;
		min-height: 50px;
		height: auto;
	}
</style>
